import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';



@Component({
  selector: 'app-email-log-detail',
  templateUrl: './email-log-detail.component.html',
  styleUrls: ['./email-log-detail.component.css']
})
export class EmailLogDetailComponent implements OnInit {

  @Input() public subject: any;
  @Input() public to: string;
  @Input() public email_body: string;
  safeHtmlBody: SafeHtml = '';

  constructor(private activeModalService: NgbActiveModal, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.safeHtmlBody = this.sanitizer.bypassSecurityTrustHtml(this.email_body);
  }

  onClose() {
    this.activeModalService.close();
  }

}
